
const digest = '452e772c3a1e70a8a832ef70ea2981a1f2a425811d6d3b1d2396c3e71c3cffa9';
const classes = {"wrapper":"_wrapper_nkkqh_1","content":"_content_nkkqh_7","text":"_text_nkkqh_12","controls":"_controls_nkkqh_18"};
const css = `._wrapper_nkkqh_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_nkkqh_1 ._content_nkkqh_7 {
  background-color: #eaedf3;
  margin: -34px -24px 12px -24px;
  padding: 30px 24px 20px 24px;
}
._wrapper_nkkqh_1 ._text_nkkqh_12 {
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 10px;
}
._wrapper_nkkqh_1 ._controls_nkkqh_18 {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  